export interface IChangeCurrentUserPasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export class ChangeCurrentUserPasswordRequest
  implements IChangeCurrentUserPasswordRequest {
  oldPassword: string;
  newPassword: string;
}
